<template>
  <div class="chat-container">
    <button v-if="!isOpen" id="chat-button" @click="toggleChat" aria-label="Abrir chat">
      <i class="fas fa-comments"></i>
    </button>

    <transition name="pop">
      <div v-if="isOpen" id="chat-window">
        <div class="chat-header">
          <div class="d-flex align-items-center">
            <div class="avatar-status">
              <i class="fas fa-headset"></i>
              
            </div>
            <div class="ml-3">
              <h6 class="mb-0 text-white font-weight-bold">Suporte Soul</h6>
              <small :class="isWorkingHours ? 'text-white-50' : 'text-warning'">
               <i class="fas fa-circle" :class="isWorkingHours ? 'fa-green':'fa-red'"></i> {{ isWorkingHours ? 'Online agora' : 'Offline (Seg-Sex, 08h-17h)' }}
              </small>
            </div>

            <span :class="['status-indicator', isWorkingHours ? 'bg-success' : 'bg-secondary']"></span>
          </div>
          <button class="close-btn" @click="toggleChat">&times;</button>
        </div>

        <div class="chat-body" ref="chatContent">
          <div v-for="(msg, index) in mensagens" :key="index" @click="handleClick"
            :class="['msg-wrapper', msg.type === 'bot' ? 'wrapper-in' : 'wrapper-out']">

            <div :class="['msg-bubble', msg.type === 'bot' ? 'bubble-in' : 'bubble-out']">
              <div v-if="msg.text" v-html="msg.text"></div>
              <div v-if="msg.file" class="attachment-msg">
                <i class="fas fa-paperclip"></i> {{ msg.file }}
              </div>
            </div>
          </div>
        </div>

        <div class="chat-footer">
          <form @submit.prevent="sendMessage" class="chat-form">
            <div class="input-container">
              <button type="button" class="action-btn" @click="triggerFile" title="Anexar arquivo">
                <i class="fas fa-plus"></i>
              </button>

              <input type="file" ref="fileInput" @change="anexarArquivo" style="display: none" :disabled="input_text">

              <input v-model="newText" type="text" class="main-input" placeholder="Escreva sua mensagem..."
                :disabled="input_text">

              <button class="send-btn" type="submit" :disabled="!newText.trim() && input_text">
                <i class="fas fa-paper-plane"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'ChatSuporte',
  data() {
    return {
      isOpen: false,
      newText: '',
      mensagens: [],
      start_support: false,
      end_support: false,
      search_client_document: false,
      matters: false,
      status_protocol: false,
      question_client: false,
      generate_protocol: false,
      search_protocol: false,
      register_new_message: false,
      input_text: true,
      clientId: '',
      subject: 'Diversos',
      polling: null,
      searchForNewMessages: false,
      userId: '',
      loading: false,
      holidays: [],
    };
  },
  beforeUnmount() {
    this.stopPolling();
  },
  mounted() {
    const currentYear = new Date().getFullYear();
    fetch(`https://brasilapi.com.br/api/feriados/v1/${currentYear}`)
      .then(response => response.json())
      .then(data => {
        this.holidays = data.map(f => f.date);
      })
      .catch(err => console.error("Erro ao buscar feriados", err));
  },
  computed: {
    isWorkingHours() {
      const now = new Date();
      const dayWeek = now.getDay(); // 0 (Dom) a 6 (Sab)
      const hour = now.getHours();

      const nowFormatted = now.toISOString().split('T')[0];
      if (dayWeek === 0 || dayWeek === 6) return false;
      if (this.holidays.includes(nowFormatted)) return false;
      return hour >= 8 && hour < 17;
    }
  },
  methods: {
  stopPolling() {
    if (this.polling) {
      clearInterval(this.polling);
      this.polling = null;
    }
  },
    injectMessage(type, text) {
      this.mensagens.push({ type: type, text: text });
    },
    messageWellcome() {
      if (this.start_support) {
        this.injectMessage('bot', '<p class="text-justify">Olá! Seja bem-vindo(a) ao nosso suporte. Sempre que desejar encerrar a conversa, basta digitar a palavra <strong>encerrar</strong> ou <strong>menu</strong> para voltar ao menu inicial.<p>');
        this.injectMessage('bot', '<p class="text-justify">Para iniciarmos, preciso que me informe seu documento (<strong>CPF ou CNPJ</strong>) de acesso para que possamos identificá-lo.</p>');
        this.input_text = false;
        this.search_client_document = true;
        this.start_support = false;
      }
    },
    messageMatters() {
      setTimeout(() => {
        this.injectMessage('bot', '<button class="btn technical_support">Suporte Técnico</button>');
        this.injectMessage('bot', '<button class="btn status_protocol">Status protocolo</button>');
        this.injectMessage('bot', '<button class="btn general_questions">Dúvidas Gerais</button>');
        this.injectMessage('bot', '<button class="btn stop_chat text-danger">Encerrar chamada</button>');
      }, 1000);
    },
    messageUserLogged() {
      const name = localStorage.getItem('name');
      setTimeout(() => {
        this.injectMessage('bot', `<p class="text-justify">Olá ${name}, tudo bem? Como podemos te ajudar hoje?</p>`);
        this.scrollToBottom();
      }, 1000);
      this.loading = false;
    },
    messageSearchDocument() {
      setTimeout(() => {
        this.injectMessage('bot', '<p class="text-justify">Por gentileza, informe seu <strong>CNPJ</strong>, caso seja Pessoa Jurídica, ou seu <strong>CPF</strong>, se Pessoa Física.</p>');
        this.scrollToBottom();
      }, 1000);
      this.loading = false;
    },
    messageHelpToday() {
      setTimeout(() => {
        this.injectMessage('bot', '<p class="text-justify">Entendi. Como podemos ajudá-lo(a) hoje?</p>');
        this.scrollToBottom();
      }, 1000);
    },
    messageStatusProtocol() {
      setTimeout(() => {
        this.injectMessage('bot', '<p class="text-justify">Por gentileza, informe o número do protocolo. Ele segue o seguinte padrão: <strong>xxxx-xxxxxx</strong></p>');
        this.scrollToBottom();
      }, 1000);
    },
    messageProtocolGegenerate(protocol, date, hour) {
      setTimeout(() => {
        this.injectMessage('bot', `<p class="text-justify">Sua mensagem já está conosco e em breve alguém do nosso time irá respondê-lo(a), tudo bem? Seu nº de protocolo é: <strong>${protocol}</strong> aberto em ${date} às ${hour}</p>`);
        this.scrollToBottom();
      }, 1000);
      this.loadNewMessages();
    },
    loadNewMessages() {
      const protocol = localStorage.getItem('protocol_help_desk');
      this.stopPolling();
      this.polling = setInterval(() => {
        if (this.searchForNewMessages) {
          this.searchProtocol(protocol);
        }
      }, 45000);
    },
    handleClick(e) {
      const technical_support = e.target.closest(".technical_support");
      const status_protocol = e.target.closest(".status_protocol");
      const general_questions = e.target.closest(".general_questions");
      const stop_chat = e.target.closest(".stop_chat");

      if (technical_support) {
        this.injectMessage('user', 'Suporte Técnico');
        this.input_text = false;
        this.messageHelpToday();
        this.question_client = true;
        this.generate_protocol = true;
        this.search_protocol = false;
        this.matters = false;
        this.subject = 'Suporte Técnico';
      } else if (status_protocol) {
        this.injectMessage('user', 'Status protocolo');
        this.input_text = false;
        this.messageStatusProtocol();
        this.question_client = true;
        this.generate_protocol = false;
        this.search_protocol = true;
        this.matters = false;
        this.subject = 'Consultar protocolo';
      } else if (general_questions) {
        this.injectMessage('user', 'Dúvidas Gerais');
        this.input_text = false;
        this.messageHelpToday();
        this.question_client = true;
        this.generate_protocol = true;
        this.search_protocol = false;
        this.matters = false;
        this.subject = 'Dúvidas gerais';
      } else if (stop_chat) {
        this.injectMessage('user', 'Encerrar chamada');
        this.injectMessage('bot', '<p class="text-justify">Seu atendimento foi encerrado. Agradecemos pelo contato.</p>');
        this.input_text = false;
        this.generate_protocol = false;
        this.search_protocol = false;
        this.register_new_message = false;
        this.matters = false;
        this.messageMatters();
      }
      this.scrollToBottom();
    },
    converterLinks(text) {
      const regexUrl = /((https?:\/\/)|(www\.))[^\s]+/g;
      return text.replace(regexUrl, (url) => {
        let href = url.toLowerCase().startsWith('www.') ? 'http://' + url : url;
        return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
      });
    },
    toggleChat() {
      this.isOpen = !this.isOpen;
      this.searchForNewMessages = this.isOpen;
      const protocol = localStorage.getItem('protocol_help_desk');

      if (protocol != null) {
        this.searchProtocol(protocol);
        this.loadNewMessages();
        this.register_new_message = true;
        this.input_text = false;
      } else {
        const user_id = localStorage.getItem('user_id');
        if (user_id != null) {
          if (this.mensagens.length <= 0) {
            this.start_support = false;
            this.matters = true;
            this.messageUserLogged();
            this.messageMatters();
          }
        } else if (this.mensagens.length <= 0) {
          this.start_support = true;
          this.messageWellcome();
        }
      }
      if (this.isOpen) this.scrollToBottom();
      else this.stopPolling();
    },
    searchDocumentUser(document) {
      api.get('/search-user/' + document)
        .then((response) => {
          this.search_client_document = false;
          this.matters = true;
          this.userId = response.data.user;
          localStorage.setItem('user_id', response.data.user);
          localStorage.setItem('name', response.data.name);
          this.mensagens = [];
          this.injectMessage('bot', '<p class="text-justify">Encontramos o seu cadastro. Agora, por gentileza, poderia escolher qual assunto deseja tratar?</p>');
          this.messageMatters();
          this.input_text = true;
          this.scrollToBottom();
        }).catch(error => {
          if (error.status == 404) {
            this.injectMessage('bot', 'Desculpe-nos, mas não conseguimos identificar seu cadastro. Verifique o documento.');
          } else {
            this.injectMessage('bot', 'Erro ao verificar registro. Tente novamente mais tarde.');
          }
          this.scrollToBottom();
        });
    },
    searchProtocol(protocol) {
      api.get('/search-protocol/' + protocol)
        .then((response) => {
          if (response.data.data.status == 'Finalizado') {
            this.mensagens = [];
            response.data.data.messages.forEach(msg => {
              this.injectMessage(msg.agent, '<p class="text-justify">' + this.converterLinks(msg.message) + '</p>');
            });
            this.injectMessage('bot', `<p class="text-justify">O protocolo <strong>${protocol}</strong> foi encerrado.</p>`);
            localStorage.removeItem('protocol_help_desk');
            this.messageMatters();
            return;
          }
          this.mensagens = [];
          response.data.data.messages.forEach(msg => {
            this.injectMessage(msg.agent, '<p class="text-justify">' + this.converterLinks(msg.message) + '</p>');
          });
          this.register_new_message = true;
          localStorage.setItem('protocol_help_desk', protocol);
          this.scrollToBottom();
        }).catch(() => {
          localStorage.removeItem('protocol_help_desk');
        });
    },
    createNumberProtocol(message) {
      api.get('/create-number-protocol', {
        params: {
          'subject': this.subject,
          'type': 'text',
          'user_id': localStorage.getItem('user_id'),
          'message': message
        }
      }).then((response) => {
        const data = response.data.data;
        localStorage.setItem('protocol_help_desk', data.protocol);
        this.mensagens = [];
        this.injectMessage('user', message);
        this.messageProtocolGegenerate(data.protocol, data.created_at_date, data.created_at_hour);
        this.generate_protocol = false;
        this.register_new_message = true;
        this.input_text = false;
        this.scrollToBottom();
      });
    },
    stopTicket() {
      const protocol = localStorage.getItem('protocol_help_desk');
      this.$confirm({
        message: 'Deseja encerrar o suporte?',
        button: { no: 'Não', yes: 'Sim' },
        callback: confirm => {
          if (confirm) {
            api.post('/close-protocol/' + protocol).then(() => {
              this.stopPolling();
              this.mensagens = [];
              localStorage.removeItem('user_id');
              localStorage.removeItem('name');
              localStorage.removeItem('protocol_help_desk');
              this.injectMessage('bot', '<p class="text-justify">Atendimento encerrado. Obrigado!</p>');
              setTimeout(() => { this.isOpen = false; }, 3000);
            });
          }
        }
      });
    },
    registerMessage(message) {
      api.post('/register-message/' + localStorage.getItem('protocol_help_desk'), {
        'type': 'text', 'message': message, 'agent': 'user'
      }).then(() => {
        this.newText = '';
        this.scrollToBottom();
      });
    },
    sendMessage() {
      if (this.newText.trim() === '') return;
      const message_send = this.newText.trim();
      const message_lower = message_send.toLowerCase();
      this.injectMessage('user', message_send);
      this.newText = '';
      this.scrollToBottom();

      setTimeout(() => {
        if (message_lower === 'encerrar') {
          this.stopTicket();
        } else if (message_lower === 'menu') {
          if (this.userId) this.messageMatters();
          else {
            this.start_support = true;
            this.messageWellcome();
          }
        } else if (this.start_support) {
          this.messageSearchDocument();
          this.start_support = false;
          this.search_client_document = true;
        } else if (this.search_client_document) {
          this.searchDocumentUser(message_lower);
        } else if (this.generate_protocol && this.question_client && !this.register_new_message) {
          this.createNumberProtocol(message_lower);
        } else if (this.search_protocol) {
          this.searchProtocol(message_lower);
        } else if (this.register_new_message) {
          this.registerMessage(message_send);
        }
        this.scrollToBottom();
      }, 1000);
    },
    triggerFile() {
      this.$refs.fileInput.click();
    },
    anexarArquivo(event) {
      const file = event.target.files[0];
      if (file) {
        this.mensagens.push({ type: 'user', file: file.name });
        this.scrollToBottom();
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.chatContent;
        if (container) container.scrollTop = container.scrollHeight;
      });
    }
  }
};
</script>

<style scoped>
#chat-button {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #042F5F 0%, #007bff 100%);
  color: white;
  border: none;
  box-shadow: 0 8px 25px rgba(4, 47, 95, 0.4);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  cursor: pointer;
  transition: transform 0.2s;
}

#chat-button:hover {
  transform: scale(1.1);
}

#chat-window {
  position: fixed;
  bottom: 100px;
  right: 30px;
  width: 380px;
  height: 600px;
  max-height: calc(100vh - 120px);
  background-color: #f4f7f6;
  border-radius: 20px;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  z-index: 1050;
  overflow: hidden;
}

.chat-header {
  background: #042F5F;
  color: white;
  padding: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.avatar-status {
  position: relative;
  width: 35px;
  height: 35px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-indicator {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 10px;
  height: 10px;
  background: #28a745;
  border: 2px solid #042F5F;
  border-radius: 50%;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 22px;
  cursor: pointer;
  opacity: 0.8;
}

.chat-body {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.msg-wrapper {
  display: flex;
  width: 100%;
}

.wrapper-in {
  justify-content: flex-start;
}

.wrapper-out {
  justify-content: flex-end;
}

.msg-bubble {
  padding: 10px 15px;
  font-size: 14px;
  max-width: 85%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.bubble-in {
  background: white;
  color: #333;
  border-radius: 4px 15px 15px 15px;
}

.bubble-out {
  background: #042F5F;
  color: white;
  border-radius: 15px 15px 4px 15px;
}

::v-deep .msg-bubble button {
  display: block;
  width: 100%;
  margin-top: 8px;
  background: #fff;
  border: 1px solid #042F5F;
  color: #042F5F;
  padding: 6px;
  border-radius: 8px;
  font-size: 13px;
  cursor: pointer;
}

::v-deep .msg-bubble button:hover {
  background: #042F5F;
  color: #fff;
}

.chat-footer {
  padding: 12px;
  background: white;
  border-top: 1px solid #eee;
}

.chat-form {
  width: 100%;
}

.input-container {
  display: flex;
  background: #f0f2f5;
  border-radius: 25px;
  padding: 5px 12px;
  align-items: center;
  width: 100%;
}

.main-input {
  flex: 1;
  border: none;
  background: transparent;
  padding: 8px;
  outline: none;
  font-size: 14px;
  min-width: 0;
}

.action-btn {
  border: none;
  background: none;
  color: #888;
  cursor: pointer;
  padding: 0 5px;
}

.send-btn {
  border: none;
  background: none;
  color: #042F5F;
  font-size: 18px;
  cursor: pointer;
  padding: 0 5px;
}

.pop-enter-active {
  animation: pop-in 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.pop-leave-active {
  animation: pop-in 0.2s reverse;
}

@keyframes pop-in {
  0% {
    opacity: 0;
    transform: scale(0.5) translateY(50px);
    transform-origin: bottom right;
  }

  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* Ajuste Mobile: Ocupa toda a tela 
*/
@media (max-width: 576px) {
  #chat-window {
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
    max-height: 100% !important;
    border-radius: 0;
  }

  /* Ajuste no header para telas cheias */
  .chat-header {
    border-radius: 0;
    padding-top: 20px;
  }

  #chat-button {
    bottom: 20px;
    right: 20px;
  }
}

.status-indicator {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 10px;
  height: 10px;
}

.fa-green{
  color: #07a82a;
}

.fa-red{
  color: #ce0909;
}
</style>